export enum WarningLevel {
    Success = 1,
    Warning = 2,
    Error = 3,
    Info = 0,
    Question = 5,
}